// 지금 캐릭터(저장 범위) 한 곳: 저장 모듈의 기본 저장소(game/save.ts·daily.ts)가 여기서 저장소를 받는다.
// 캐릭터가 정해지지 않았으면(캐릭터 기능 꺼짐·이관 전·저장소 막힘) 원래 키를 그대로 쓴다 — 지금 빌드와 같은 동작(호환 경로).
// 부팅 순서: bootCharacters()(index.ts)가 createGame 전에 activateCharacter를 부른다. 게임이 만들어진 뒤에는 바꾸지 않는다
// (캐릭터 바꾸기 = 선택 저장 후 새로고침 — 저장 모듈이 메모리에 든 진행을 다른 캐릭터 키에 쓰지 않게).
import { CharacterStorage, type StorageArea } from './keys';
import { isCharacterId } from './protocol';

let active: string | null = null;

/** 지금 캐릭터 id(없으면 null = 원래 키) */
export function activeCharacterId(): string | null { return active; }

/** 부팅 때 한 번(createGame 전). 형식이 틀린 id는 무시하고 null */
export function activateCharacter(id: string | null): void { active = id !== null && isCharacterId(id) ? id : null; }

/** 저장 모듈이 쓸 저장소: 캐릭터가 있으면 그 캐릭터 저장소, 없으면 base 그대로 */
export function scopedStorage<T extends StorageArea>(base: T): T | CharacterStorage {
  return active === null ? base : new CharacterStorage(base, active);
}
